/*-----------------------------------------------------------------
- Fields translations
-----------------------------------------------------------------*/
export default {

    continent   : 'القارة',
    country     : 'بلد',
    province    : 'دولة',
    city        : 'مدينة',
    neighborhood: 'حي',
    login       : 'تسجيل الدخول',
};
